import { PrismicRichText } from '@prismicio/react';
import { clsx } from 'clsx';
import { ReactElement } from 'react';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { IProps } from './types';
import * as S from './styles';

export function SliceProductFeatures({
  slice: { primary, fields },
}: IProps): ReactElement {
  return (
    <S.Wrapper className="product-features">
      <S.Padding>
        <S.Header>
          {primary.title && <PrismicRichText field={primary.title} />}
        </S.Header>
        {fields && (
          <S.List className="product-features__list">
            {fields.map((item, i) => (
              <S.Item
                key={i}
                className={clsx('product-features__item', {
                  'product-features__item-rate': item.text,
                })}
              >
                <S.ItemImage className="product-features__item-image">
                  {item.image && (
                    <PrismicNextImage
                      field={item.image}
                      width={320}
                      height={320}
                      style={{ maxWidth: 'auto', height: '100%' }}
                      sizes="(max-width: 1278px) 100vw, 33vw"
                    />
                  )}
                  {item.video && (
                    <iframe
                      className="vimeo"
                      src={`https://player.vimeo.com/video/${item.video.video_id}?autoplay=1&loop=1&muted=1&controls=0`}
                      frameBorder="0"
                      allow="autoplay"
                      allowFullScreen
                      title="video"
                    />
                  )}
                </S.ItemImage>
                <S.ItemContent className="product-features__item-content">
                  <S.ItemTitle className="product-features__item-title">
                    {item.sub_title && (
                      <PrismicRichText field={item.sub_title} />
                    )}
                  </S.ItemTitle>
                  <S.ItemDescription className="product-features__item-descr">
                    {item.text && <PrismicRichText field={item.text} />}
                  </S.ItemDescription>
                </S.ItemContent>
              </S.Item>
            ))}
          </S.List>
        )}
        <S.Footer className="product-features-bottom">
          {primary.subtitle && (
            <S.FooterWrapper className="product-features-bottom__wr">
              <S.FooterTitle className="product-features-bottom__title">
                {primary.icon && (
                  <img src={primary.icon.url} alt={primary.icon.alt} />
                )}
                {primary.subtitle && (
                  <PrismicRichText field={primary.subtitle} />
                )}
              </S.FooterTitle>
              <S.ItemDescription className="product-features-bottom__descr">
                {primary.text && <PrismicRichText field={primary.text} />}
              </S.ItemDescription>
            </S.FooterWrapper>
          )}
        </S.Footer>
      </S.Padding>
    </S.Wrapper>
  );
}

SliceProductFeatures.componentName = 'product_features';

export default SliceProductFeatures;
